export class CreateTransactionProduct {
    transactionManagementId?: number;
    productId: number;
    warehouseId: number;
    productCount: number;
    productPrice: number;
    taxId: number;
    discountRate: number;
    currencyId: number;
    description?: string
    seriNos?:string[];
    saleSerialNos?:number[];
    createTransactionAdditionalFeatureMatching:any[];
}